import type { ReactNode } from 'react';
import { Avatar, Flex, Tooltip } from 'ui';
import type { VirtualChatMessageRow } from '../../types';
import { useChatMessageLayout } from './hooks';

type P = {
  children: ReactNode;
  row: VirtualChatMessageRow;
  tooltipTitle?: string;
};

const ChatMessageLayout = ({ children, row, tooltipTitle }: P) => {
  const { messagesAlignment, outerAlignment, shouldShowAvatar, shouldShowAvatarSpacer, src } = useChatMessageLayout({
    row,
  });

  return (
    <Flex
      align={outerAlignment}
      className="chat-message-layout"
      gap="xs"
      vertical={!shouldShowAvatar && !shouldShowAvatarSpacer}
    >
      {shouldShowAvatar ? (
        <Tooltip placement="left" title={tooltipTitle}>
          <Avatar src={src} />
        </Tooltip>
      ) : null}
      {shouldShowAvatarSpacer ? <div aria-hidden className="chat-message-layout__avatar-spacer" /> : null}

      <Flex align={messagesAlignment} className="chat-message-layout__messages" gap="xxxs" vertical>
        {children}
      </Flex>
    </Flex>
  );
};

export default ChatMessageLayout;
